// extracted by mini-css-extract-plugin
module.exports = {"taskName":"StaticRatingLabel_taskName__pIRPJ","humanRankedValue":"StaticRatingLabel_humanRankedValue__2T_ad"};